<template>
  <div class="title_cont">
    <h2 class="title_txt">마이페이지</h2>
    <ul class="protocol_search_tab">
      <template v-for="(item, i) in links">
        <li
            :key="i"
            @click="showLnb = item"
            @mouseenter="showLnb = item"
            @mouseover="showLnb = item"
            @mouseleave="showLnb = null"
            :class="[item.onUrlList.includes($route.path) ? 'on' : '']"
        >
          <router-link :to="{ path:`${item.url}`,
                                        query: item.query
                                        }">
            {{ item.name }}
          </router-link>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      links: []
    }
  },
  async mounted() {
    // 로그인 여부 확인.
    let userData = await this.$wApi.user.mypage.me();
    if (userData == null || userData?.error) {
      this.$router.push("/account/login");
    }

    this.links.push(
      {
        name: "회원정보",
        url: "/account/mypage",
        onUrlList: ["/account/mypage"],
      });

      if(this.user.committee){
        this.links.push(
            {
              name: "작성목록",
              url: "/account/mypage/createdList",
              onUrlList: ["/account/mypage/createdList", "/account/mypage/CreatedDetail"],
              query: {tabIndex: 0},
            }
        )
      }

    // 문헌 수집 — 로그인 사용자 전체 (2026-09-27 결정)
    this.links.push(
        {
          name: "문헌 업로드 토큰",
          url: "/account/mypage/lit-token",
          onUrlList: ["/account/mypage/lit-token"],
        }
    );

    if (this.$route.path == this.links[0].url) {
      // console.log("마이페이지 진입 비밀번호 확인 필요. => 디자인 나오면 적용.");
    }
  }
};
</script>